"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCookieConsent = void 0;
var AnalyticsProvider_1 = require("../AnalyticsProvider");
function useCookieConsent() {
    var _a = (0, AnalyticsProvider_1.useAnalyticsContext)(), consent = _a.consent, isTrackingCookieAllowed = _a.isTrackingCookieAllowed, setConsent = _a.setConsent, newsroom = _a.newsroom;
    function accept() {
        var _a;
        if (newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent.is_enabled) {
            (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
            return;
        }
        setConsent(true);
    }
    function reject() {
        var _a;
        if (newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent.is_enabled) {
            (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
            return;
        }
        setConsent(false);
    }
    function toggle() {
        var _a;
        if (newsroom === null || newsroom === void 0 ? void 0 : newsroom.onetrust_cookie_consent.is_enabled) {
            (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
            return;
        }
        setConsent(!consent);
    }
    return {
        // flags
        isTrackingCookieAllowed: isTrackingCookieAllowed,
        isNavigatorSupportsCookies: typeof navigator !== 'undefined' && navigator.cookieEnabled,
        // API
        accept: accept,
        reject: reject,
        toggle: toggle,
    };
}
exports.useCookieConsent = useCookieConsent;
//# sourceMappingURL=useCookieConsent.js.map